module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAATlJREFUWAnl2N0NgjAUBWAwTsLPAG7gq7qFcRpnMLzpACbqmys4gIFV8B4VAgFKL0E4xCbVAi39KiQ90XH+qaRp6nqet0ZFe4i1z7pOAqDv+wcZf0GV9qrrvTTjOoEL2K1msj76qsEN2CiO41sfoLZ7qN47A3bnum7aNlkf163BDFgs2ArMgrUCM2FbwWxYI5gR2whmxdaCmbEVMDu2BJ4CNgcDGwTBXb6XOIkiO9dD6vlzNPrnU8oJu+kcFMHui1ick+MFKtoMJQxDMI5Z+BkkB/Sx8PfWLL/kZF6JPEsA/Q3kxYyL2DhYErN5AjkYnaeALoGngK6A2dG1YGZ0I5gVbQQzolvBbGgrMBPaGsyCVoEZ0GqwAb1JkuSK678sWVpTzYFciowhgyLVwLE7I3sM/Xfr2GtWz/8CVXsUAD71xrEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/left.png
// module id = 918
// module chunks = 1